// Browser storage can be unavailable in Safari private mode, embedded browsers,
// or when the user blocks site storage. Storage must never be allowed to crash
// authentication, the dashboard, or public pages.
function getStorage(kind) {
  if (typeof window === 'undefined') return null;
  try {
    return window[kind] || null;
  } catch {
    return null;
  }
}

export function safeLocalGet(key, fallback = null) {
  try { return getStorage('localStorage')?.getItem(key) ?? fallback; } catch { return fallback; }
}

export function safeLocalSet(key, value) {
  try { getStorage('localStorage')?.setItem(key, String(value)); return true; } catch { return false; }
}

export function safeSessionGet(key, fallback = null) {
  try { return getStorage('sessionStorage')?.getItem(key) ?? fallback; } catch { return fallback; }
}

export function safeSessionSet(key, value) {
  try { getStorage('sessionStorage')?.setItem(key, String(value)); return true; } catch { return false; }
}
